/** Matches promotions PromotionKind */
export const PromotionKind = {
  Incentive: "INCENTIVE",
  Rebate: "REBATE",
} as const;
export type PromotionKind = (typeof PromotionKind)[keyof typeof PromotionKind];

export type Incentive = {
  id: number;
  kind: typeof PromotionKind.Incentive;
  title: string;
  description: string;
  details: string;
};

export type Rebate = {
  id: number;
  kind: typeof PromotionKind.Rebate;
  title: string;
  description: string;
  details: string;
};

/** Matches PromoCodeSerializer */
export interface IPromoCode {
  id: number;
  incentive: null | number;
  rebate: null | number;
  code: string;
}

/** matches promotions CommonPromotionSerializer / PromotionDetail */
export type Promotion = Incentive | Rebate;

/** Matches promotions IncentiveStatus  */
export const IncentiveStatus = {
  Live: "LIVE",
  Upcoming: "UPCOMING",
  Expired: "EXPIRED",
  Inactive: "INACTIVE",
} as const;
export type IncentiveStatus = (typeof IncentiveStatus)[keyof typeof IncentiveStatus];
